import { SegmentType } from "../types/segments.types";
import { SEGMENT_TYPE_CONFIG } from "../constants/segments.constants";
import { Tooltip } from "../../../../../components/Tooltip/Tooltip";

const SegmentTypeTooltipContent = ({ type }: { type: SegmentType }) => {
  const config = SEGMENT_TYPE_CONFIG[type];
  return (
    <div className="flex flex-col gap-[6px]">
      <div className="flex items-center gap-[4px]">
        <div className={`w-[6px] h-[6px] rounded-full ${config.dotColor}`} />
        <span className="text-md font-medium text-pure-white dark:text-pure-white-dk capitalize">
          {config.label}
        </span>
      </div>
      <p className="text-sm font-normal text-pure-white dark:text-pure-white-dk leading-normal">
        {config.description}
      </p>
    </div>
  );
};

const SegmentTypeBadge = ({ type }: { type: SegmentType }) => {
  const config = SEGMENT_TYPE_CONFIG[type];
  return (
    <Tooltip
      content={<SegmentTypeTooltipContent type={type} />}
      side="top"
      align="center"
      sideOffset={8}
      maxWidth="250px"
      contentClassName="text-sm !px-[12px] !py-[12px]"
    >
      <div className="flex gap-[4px] items-center px-[6px] py-[2px] h-[20px] bg-pure-white dark:bg-pure-white-dk border border-border-gray dark:border-border-gray-dk rounded-[6px] shadow-xs w-fit cursor-default">
        <div className={`w-[6px] h-[6px] rounded-full ${config.dotColor}`} />
        <span className="text-xs font-medium text-verba-indigo dark:text-verba-indigo-dk capitalize whitespace-nowrap">
          {config.label}
        </span>
      </div>
    </Tooltip>
  );
};

export default SegmentTypeBadge;
